import Vue from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia/dist/pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(
  createPersistedState({
    storage: sessionStorage,
    key: id => `shr-${id}`
  })
);
export default pinia;
